import {useEffect, useState} from 'react';

import {fetchWhatsappConversations} from '../utils/whatsappConversations';
import {subscribeWorkspaceEvents} from '../utils/workspaceRealtime';

const clampTotal = (value) => {
  const total = Number(value);
  return Number.isFinite(total) ? Math.max(0, Math.floor(total)) : 0;
};

export default function useWhatsappUnreadCount(workspaceId, userId) {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    let active = true;
    let eventVersion = 0;
    let requestSequence = 0;
    setUnreadCount(0);
    if (!workspaceId || !userId) return undefined;

    const refresh = () => {
      const version = eventVersion;
      const request = ++requestSequence;
      return fetchWhatsappConversations({workspaceId, limit: 1})
      .then(({unreadTotal}) => {
        if (active && request === requestSequence && version === eventVersion) {
          setUnreadCount(clampTotal(unreadTotal));
        }
      })
      .catch(() => undefined);
    };
    const subscription = subscribeWorkspaceEvents({
      workspaceId,
      userId,
      onEvent: (event) => {
        if (event?.workspaceId !== workspaceId
          || !['whatsapp.inbound_received', 'whatsapp.read_changed'].includes(event.type)) return;
        eventVersion += 1;
        if (active) setUnreadCount(clampTotal(event.payload?.unreadTotal));
      },
      onReconnect: refresh,
    });
    subscription.ready.then(() => {
      if (active) refresh();
    });

    return () => {
      active = false;
      subscription.unsubscribe();
    };
  }, [userId, workspaceId]);

  return unreadCount;
}
